import $http from '../../../../../axios-instance';

/**
 * Obtener las Indicaciones de peligro asociadas al producto.
 *
 * @param Object commit
 * @param Object params: { productId, versionId, languageId}
 */
export async function getDangerIndicationsByProduct({ commit }, params) {
    commit("dashboard/load", true, { root: true });
    commit("setDangerIndications", []);
    try {
        
        const { data: response } = await $http.get(`products/sga2/danger-indications/`, { params });
        commit("setDangerIndications", response.data);

    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}